// GalleryMarkerManager.js
import { OnePointMarker } from './OnePointMarker.js';
import {TwoPointCircleMarker} from "./TwoPointCircleMarker.js";
import {ThreePointViewMarker} from "./ThreePointViewMarker.js";
import {FivePointPlaneMarker} from "./FivePointPlaneMarker.js";
import { LocationShapeLayer } from '../LocationShapeLayer.js';
// Importiere bei Bedarf weitere Markerklassen

export class GalleryMarkerManager {
    markerFactory;

    offsetOptions = {
        // offsetX: 0.0001,
        // offsetY: 0.0001
    }

    constructor(mapAdapter, markerFactory) {
        this.mapAdapter = mapAdapter;
        this.markerFactory = markerFactory;
        this.markers = [];
        // EINE Canvas-Ebene (markerLayer, ÜBER den getilten Overlays) für ALLE Viewpoint-Formen — read-only, WYSIWYG zur
        // Editor-Anzeige (dieselbe Formen-Mathe wie LocationShapeLayer). Löst die per-Marker google.maps.Circle/Polygon ab,
        // die im overlayLayer UNTER den Overlays lagen. Lazy erstellt beim ersten addMarkers (braucht die Karten-Instanz).
        this.shapeLayer = null;
    }

    clearAll() {
        for (const m of this.markers) m.clear();
        this.markers = [];
        if (this.shapeLayer) { this.shapeLayer.setShapes([]); }
    }

    addMarkers(map, { locations = [], viewpoints = [] } ) {
        // ToDo: legacy check wegen viewpoints, aber erst abklären
        let fusedLocations = [...locations, ...viewpoints];
        this.clearAll();

        if (!this.shapeLayer && map) { this.shapeLayer = new LocationShapeLayer(map); }

        const shapes = [];
        for (const loc of fusedLocations) {
            const points = loc.markers.map(m => ({
                lat: parseFloat(m.lat),
                lng: parseFloat(m.lng)
            }));

            let options = { color: '#24F4FF' };   // vereinheitlicht auf das Legacy-Cyan (früher #03f5f1) — Origin-Ring-Farbe
            options = {...options, ...this.offsetOptions };

            // Origin-Marker (AdvancedMarker, über den Overlays) je Location; die Form selbst zeichnet die shapeLayer.
            const marker = this.getGalleryMarker(points, null, options, loc);
            if (marker) {
                marker.draw(map);
                this.markers.push(marker);
            }
            if (points.length >= 2) { shapes.push({ points }); }   // 1 Punkt = nur Origin-Marker, keine Form
        }

        if (this.shapeLayer) { this.shapeLayer.setShapes(shapes); }
    }

    getGalleryMarker(points, marker, options, loc) {
        switch (points.length) {
            case 1:
                return new OnePointMarker(this.mapAdapter, this.markerFactory, points, options);
            case 2:
                return new TwoPointCircleMarker(this.mapAdapter, this.markerFactory, points, options);
            case 3:
                return new ThreePointViewMarker(this.mapAdapter, this.markerFactory, points, options);
            case 5:
                return new FivePointPlaneMarker(this.mapAdapter, this.markerFactory, points, options);
            default:
                console.warn('Unknown marker shape for location', loc);
                return null;
        }
    }

    getMarkers(index = null) {
        if(index != null && index > this.markers.length - 1) {
            console.error("[GalleryMarkerManager] getMarkers: index not found: ", index);
            return;
        }

        if (index === null) {
            return this.markers;
        } else {
            return [this.markers[index]];
        }
    }
}
